import { IconButton } from '@mui/material';
import { GridToolbarContainer } from '@mui/x-data-grid';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

function EscoDataGridToolbar(props) {

    const navigate = useNavigate();

    const handleVolverClick = () => {
        navigate(-1); // Vuelve a la página anterior en el historial
    };

    return (
        <GridToolbarContainer>
        <IconButton
            onClick={handleVolverClick}
            color="primary"
            style={{
                fontSize: '0.875rem', 
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif', 
            }}
        >
            <ArrowBackIosNewIcon /> Volver
        </IconButton>
    </GridToolbarContainer>
    );
}

export default EscoDataGridToolbar;